import Vue from "vue";
import Vuex from 'vuex'
import layoutTemplate from "../src/template/store/layout";
import authTemplate from "../src/template/store/auth";
import registerTemplate from "../src/template/store/register";
import productsTemplate from "../src/template/store/products";
import usersListTemplate from "../src/template/store/usersList";
import registerMain from "../src/main/modules/User/store/register";
import languageMain from "../src/main/store/language";
import loginMain from "../src/main/modules/User/store/login";
import forgetPassword from "../src/main/modules/User/store/forgetPassword";
import resetPassword from "../src/main/modules/User/store/resetPassword";
import tokenResetPasswordExist from "../src/main/modules/User/store/tokenResetPasswordExist";
import myCompanyDataSave from "../src/main/modules/Company/store/myCompanyDataSave";
import layoutCompany from "../src/main/modules/Company/store/layoutCompany";
import getCompanyUser from "../src/main/modules/Company/store/getCompanyUser";
import getClients from "../src/main/modules/Clients/store/getClients";
import deleteClient from "../src/main/modules/Clients/store/deleteClient";
import getClient from "../src/main/modules/Clients/store/getClient";
import saveClient from "../src/main/modules/Clients/store/saveClient";
import updateClient from "../src/main/modules/Clients/store/updateClient";
import saveClientPerson from "../src/main/modules/Clients/store/saveClientPerson";
import updateClientPerson from "../src/main/modules/Clients/store/updateClientPerson";
import saveEmployee from "../src/main/modules/Employees/store/saveEmployee";
import getEmployees from "../src/main/modules/Employees/store/getEmployees";
import getEmployee from "../src/main/modules/Employees/store/getEmployee";
import updateEmployee from "../src/main/modules/Employees/store/updateEmployee";
import deleteEmployee from "../src/main/modules/Employees/store/deleteEmployee";
import getCompanies from "../src/main/modules/Company/store/getCompanies";
import getCompany from "../src/main/modules/Company/store/getCompany";
import updateCompany from "../src/main/modules/Company/store/updateCompany";
import saveProject from "../src/main/modules/Projects/store/saveProject";
import getProjects from "../src/main/modules/Projects/store/getProjects";
import updateProject from "../src/main/modules/Projects/store/updateProject";
import deleteProject from "../src/main/modules/Projects/store/deleteProject";
import getProject from "../src/main/modules/Projects/store/getProject";
import saveProjectReport from "../src/main/modules/TimeReports/store/saveProjectReport";
import getTimeReports from "../src/main/modules/TimeReports/store/getTimeReports";
import getTimeReport from "../src/main/modules/TimeReports/store/getTimeReport";
import updateTimeReport from "../src/main/modules/TimeReports/store/updateTimeReport";
import deleteTimeReport from "../src/main/modules/TimeReports/store/deleteTimeReport";
import saveNote from "../src/main/modules/Notes/store/saveNote";
import deleteDocument from "../src/main/modules/Documents/store/deleteDocument";
import getDocuments from "../src/main/modules/Documents/store/getDocuments";
import getDocument from "../src/main/modules/Documents/store/getDocument";
import getBase64Document from "../src/main/modules/Documents/components/getBase64Document";
import saveDocument from "../src/main/modules/Documents/store/saveDocument";
import getHeadersDocuments from "../src/main/modules/Documents/store/getHeadersDocuments";
import updateDocument from "../src/main/modules/Documents/store/updateDocument";
import openDocument from "../src/main/modules/Documents/store/openDocument";
import getNoteHeaders from "../src/main/modules/Notes/store/getNoteHeaders";
import deleteNote from "../src/main/modules/Notes/store/deleteNote";
import updateNote from "../src/main/modules/Notes/store/updateNote";
import getNotes from "../src/main/modules/Notes/store/getNotes";
import getHeadersProjectsClient from "../src/main/modules/Clients/store/getHeadersProjectsClient";
import getProjectsClient from "../src/main/modules/Clients/store/getProjectsClient";
import saveLogo from "../src/main/modules/Company/store/saveLogo";
import updateEstimate from "../src/main/modules/Estimate/store/updateEstimate";
import updateVisibleEstimationModal from "../src/main/modules/Projects/store/updateVisibleEstimationModal";
import saveEstimate from "../src/main/modules/Estimate/store/saveEstimate";
import getEstimate from "../src/main/modules/Estimate/store/getEstimate";
import updateVisibleCreateTimeReportModal from "../src/main/modules/Projects/store/updateVisibleCreateTimeReportModal";
import updateVisibleCreateInvoiceModal from "../src/main/modules/Projects/store/updateVisibleCreateInvoiceModal";
import getHeadersTimeReportsProject from "../src/main/modules/Projects/store/getHeadersTimeReportsProject";
import getHeadersInvoiceItems from "../src/main/modules/Invoices/store/getHeadersInvoiceItems";
import saveInvoice from "../src/main/modules/Invoices/store/saveInvoice";
import getRecipients from "../src/main/modules/Invoices/store/getRecipients";
import getInvoiceNumber from "../src/main/modules/Invoices/store/getInvoiceNumber";
import getProjectReportEntries from "../src/main/modules/ProjectReportEntries/store/getProjectReportEntries";
import getProjectReportEntriesHeaders from "../src/main/modules/ProjectReportEntries/store/getProjectReportEntriesHeaders";
import deleteProjectEntry from "../src/main/modules/ProjectReportEntries/store/deleteProjectEntry";
import updateProjectEntry from "../src/main/modules/ProjectReportEntries/store/updateProjectEntry";
import saveProjectEntry from "../src/main/modules/ProjectReportEntries/store/saveProjectEntry";
import updateVisibleEstimationItemsModal from "../src/main/modules/Invoices/store/updateVisibleEstimationItemsModal";
import getHeadersInvoices from "../src/main/modules/Invoices/store/getHeadersInvoices";
import getInvoices from "../src/main/modules/Invoices/store/getInvoices";
import getBase64Invoice from "../src/main/modules/Invoices/store/getBase64Invoice";
import getInvoiceClientPersons from "../src/main/modules/Clients/store/getInvoiceClientPersons";
import updateVisibleInvoiceClientPersonsModal from "../src/main/modules/Invoices/store/updateVisibleInvoiceClientPersonsModal";
import getHeadersClientPersons from "../src/main/modules/Clients/store/getHeadersClientPersons";
import sendInvoice from "../src/main/modules/Invoices/store/sendInvoice";
import updateVisibleInvoiceSendEmailModal from "../src/main/modules/Invoices/store/updateVisibleInvoiceSendEmailModal";
import generateTimeReportPdf from "../src/main/modules/TimeReports/store/generateTimeReportPdf";
import deleteInvoice from "../src/main/modules/Invoices/store/deleteInvoice";
import getHeadersPlannedContacts from "../src/main/modules/PlannedContacts/store/getHeadersPlannedContacts";
import getPlannedContacts from "../src/main/modules/PlannedContacts/store/getPlannedContacts";
import savePlannedContact from "../src/main/modules/PlannedContacts/store/savePlannedContact";
import updatePlannedContact from "../src/main/modules/PlannedContacts/store/updatePlannedContact";
import deletePlannedContact from "../src/main/modules/PlannedContacts/store/deletePlannedContact";
import updateVisiblePlannedContactModal from "../src/main/modules/PlannedContacts/store/updateVisiblePlannedContactModal";
import updateCreatePlannedContactModal from "../src/main/modules/PlannedContacts/store/updateCreatePlannedContactModal";
import generateProjectReportPdf from "../src/main/modules/Projects/store/generateProjectReportPdf";
import sendDocument from "../src/main/modules/Documents/store/sendDocument";
import getVat from "../src/main/modules/Vat/store/getVat";
import updateVisiblePlannedContactFormModal from "../src/main/modules/Clients/store/updateVisiblePlannedContactFormModal";
import updateVisibleNoteModal from "../src/main/modules/Notes/store/updateVisibleNoteModal";
import getOldestsPlannedContacts from "../src/main/modules/PlannedContacts/store/getOldestsPlannedContacts";
import generateEstimation from "../src/main/modules/Estimate/store/generateEstimation";
import getInvoice from "../src/main/modules/Invoices/store/getInvoice";
import getOffers from "../src/main/modules/Offers/store/getOffers";
import saveOffer from "../src/main/modules/Offers/store/saveOffer";
import deleteOffer from "../src/main/modules/Offers/store/deleteOffer";
import getOffer from "../src/main/modules/Offers/store/getOffer";
import updateOffer from "../src/main/modules/Offers/store/updateOffer";
import acceptOffer from "../src/main/modules/Offers/store/acceptOffer";
import declineOffer from "../src/main/modules/Offers/store/declineOffer";
import pendingOffer from "../src/main/modules/Offers/store/pendingOffer";
import getSubscription from "../src/main/modules/Users/store/getSubscription";
import subscribe from "../src/main/modules/Users/store/subscribe";
import cancelSubscription from "../src/main/modules/UserSubscriptions/store/cancelSubscription";
import getUsers from "../src/main/modules/Users/store/getUsers";
import generateOffer from "../src/main/modules/Offers/store/generateOffer";
import getTranslationModule from "../src/main/modules/Translations/store/getTranslationModule";
import updateTranslation from "../src/main/modules/Translations/store/updateTranslation";
import saveProjectTask from "../src/main/modules/ProjectTasks/store/saveProjectTask";
import getHeadersProjectTasks from "../src/main/modules/ProjectTasks/store/getHeadersProjectTasks"
import getProjectTasks from "../src/main/modules/ProjectTasks/store/getProjectTasks";
import updateProjectTask from "../src/main/modules/ProjectTasks/store/updateProjectTask";
import deleteProjectTask from "../src/main/modules/ProjectTasks/store/deleteProjectTask";
import importEstimation from "../src/main/modules/Projects/store/importEstimation";
import saveMeasurement from "../src/main/modules/Measurements/store/saveMeasurement";
import getMeasurements from "../src/main/modules/Measurements/store/getMeasurements";
import deleteMeasurement from "../src/main/modules/Measurements/store/deleteMeasurement";
import generateMeasurementPdf from "../src/main/modules/Measurements/store/generateMeasurementPdf";
import getHeadersMeasurementItems from "../src/main/modules/Measurements/store/getHeadersMeasurementItems";
import paymentInvoice from "../src/main/modules/Invoices/store/paymentInvoice";
import updateVisibleInvoicePaidAtModal from "../src/main/modules/Invoices/store/updateVisibleInvoicePaidAtModal";
import updateVisibleProjectTaskModal from "../src/main/modules/ProjectTasks/store/updateVisibleProjectTaskModal";
import getProjectTask from "../src/main/modules/ProjectTasks/store/getProjectTask";
import getTodoTasks from "../src/main/modules/ProjectTasks/store/getTodoTasks";
import updateVisibleFavoriteContactFormModal from "../src/main/modules/Company/store/updateVisibleFavoriteContactFormModal"
import saveFavoriteContact from "../src/main/modules/Company/store/saveFavoriteContact";
import getFavoriteContacts from "../src/main/modules/Company/store/getFavoriteContacts";
import getHeadersFavoriteContacts from "../src/main/modules/Company/store/getHeadersFavoriteContacts";
import getFavoriteContact from "../src/main/modules/Company/store/getFavoriteContact";
import deleteFavoriteContact from "../src/main/modules/Company/store/deleteFavoriteContact";
import getDashboardData from "../src/main/modules/Dashboard/store/getDashboardData";
import setCompanyExemption from "../src/main/modules/Company/store/setCompanyExemption";
import updateVisibleTimeReportClientPersonsModal from "../src/main/modules/TimeReports/store/updateVisibleTimeReportClientPersonsModal";
import sendTimeReport from "../src/main/modules/TimeReports/store/sendTimeReport";
import getTimeReportClientPersons from "../src/main/modules/Clients/store/getTimeReportClientPersons";
import updateVisibleTimeReportSendEmailModal from "../src/main/modules/TimeReports/store/updateVisibleTimeReportSendEmailModal";
import updateVisibleDocumentSendEmailModal from "../src/main/modules/Documents/store/updateVisibleDocumentSendEmailModal";
import preventDataLost from "../src/main/store/preventDataLost";
import getHeadersInvoicePayments from "../src/main/modules/Invoices/store/getHeadersInvoicePayments";
import updateVisibleGuideModal from "../src/main/modules/Guides/store/updateVisibleGuideModal";
import incompleteProfile from "../src/main/store/incompleteProfile"
import updateVisibleVobDocumentModal from "../src/main/modules/VobDocuments/store/updateVisibleVobDocumentModal";
import vobDocuments from "../src/main/modules/VobDocuments/store/vobDocuments";
import getLatestMeasurement from "../src/main/modules/Measurements/store/getLatestMeasurement";
import manageEmailForm from "../src/main/components/EmailForm/store/manageEmailForm";
import sendOffer from "../src/main/modules/Offers/store/sendOffer";
import confirmInvoice from "../src/main/modules/Invoices/store/confirmInvoice";
import updateInvoice from "../src/main/modules/Invoices/store/updateInvoice";
import isProjectInvoicesConfirmed from "../src/main/modules/Invoices/store/isProjectInvoicesConfirmed";
import getProjectTimeReports from "../src/main/modules/Projects/store/getProjectTimeReports";
import getProjectDiskUsage from "../src/main/modules/Projects/store/getProjectDiskUsage";
import getClientDiskUsage from "../src/main/modules/Clients/store/getClientDiskUsage";
import getHeadersInvoicePaymentsList from "../src/main/modules/Invoices/store/getHeadersInvoicePaymentsList";
import getInvoicePaymentItems from "../src/main/modules/Invoices/store/getInvoicePaymentItems";
import deleteInvoicePaymentItem from "../src/main/modules/Invoices/store/deleteInvoicePaymentItem";
import updateVisibleTimeReportSummaryTableModal from "../src/main/modules/TimeReports/store/updateVisibleTimeReportSummaryTableModal";
import getHeadersTimeReportSummary from "../src/main/modules/TimeReports/store/getHeadersTimeReportSummary";
import confirmTimeReportSummary from "../src/main/modules/TimeReports/store/confirmTimeReportSummary";
import getCountries from "../src/main/modules/Company/store/getCountries";
import getProducts from "../src/main/modules/Products/store/getProducts";
import storeProduct from "../src/main/modules/Products/store/storeProduct";
import updateProduct from "../src/main/modules/Products/store/updateProduct";
import deleteProduct from "../src/main/modules/Products/store/deleteProduct";
import getAllProducts from "../src/main/modules/Products/store/getAllProducts";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        authTemplate,
        registerTemplate,
        productsTemplate,
        usersListTemplate,
        layoutTemplate,
        registerMain,
        languageMain,
        forgetPassword,
        loginMain,
        resetPassword,
        tokenResetPasswordExist,
        myCompanyDataSave,
        layoutCompany,
        getCompanyUser,
        getClients,
        deleteClient,
        getClient,
        saveClient,
        updateClient,
        saveClientPerson,
        updateClientPerson,
        saveEmployee,
        getEmployees,
        getEmployee,
        updateEmployee,
        deleteEmployee,
        getCompanies,
        getCompany,
        updateCompany,
        saveProject,
        getProjects,
        updateProject,
        deleteProject,
        getProject,
        saveProjectReport,
        getTimeReports,
        getTimeReport,
        deleteTimeReport,
        updateTimeReport,
        saveNote,
        deleteDocument,
        getDocuments,
        getDocument,
        getBase64Document,
        saveDocument,
        getHeadersDocuments,
        updateDocument,
        openDocument,
        saveEstimate,
        getEstimate,
        getNoteHeaders,
        deleteNote,
        updateNote,
        getNotes,
        getHeadersProjectsClient,
        getProjectsClient,
        saveLogo,
        updateEstimate,
        showEstimationModal: updateVisibleEstimationModal,
        updateVisibleCreateTimeReportModal,
        updateVisibleCreateInvoiceModal,
        updateVisibleEstimationItemsModal,
        getHeadersInvoiceItems,
        saveInvoice,
        getRecipients,
        getInvoiceNumber,
        getHeadersTimeReportsProject,
        getProjectReportEntries,
        getProjectReportEntriesHeaders,
        deleteProjectEntry,
        updateProjectEntry,
        saveProjectEntry,
        getHeadersInvoices,
        getInvoices,
        getBase64Invoice,
        getInvoiceClientPersons,
        updateVisibleInvoiceClientPersonsModal,
        sendInvoice,
        updateVisibleInvoiceSendEmailModal,
        generateTimeReportPdf,
        deleteInvoice,
        getHeadersClientPersons,
        getHeadersPlannedContacts,
        getPlannedContacts,
        savePlannedContact,
        updatePlannedContact,
        deletePlannedContact,
        updateVisiblePlannedContactModal,
        updateCreatePlannedContactModal,
        generateProjectReportPdf,
        getVat,
        sendDocument,
        generateEstimation,
        updateVisiblePlannedContactFormModal,
        updateVisibleNoteModal,
        getOldestsPlannedContacts,
        getInvoice,
        getOffers,
        saveOffer,
        deleteOffer,
        getOffer,
        updateOffer,
        acceptOffer,
        declineOffer,
        pendingOffer,
        getUsers,
        getSubscription,
        subscribe,
        cancelSubscription,
        generateOffer,
        getTranslationModule,
        updateTranslation,
        saveProjectTask,
        getHeadersProjectTasks,
        getProjectTasks,
        updateProjectTask,
        deleteProjectTask,
        importEstimation,
        saveMeasurement,
        getMeasurements,
        deleteMeasurement,
        generateMeasurementPdf,
        getHeadersMeasurementItems,
        paymentInvoice,
        updateVisibleInvoicePaidAtModal,
        updateVisibleProjectTaskModal,
        getProjectTask,
        getTodoTasks,
        updateVisibleFavoriteContactFormModal,
        saveFavoriteContact,
        getFavoriteContacts,
        getHeadersFavoriteContacts,
        getFavoriteContact,
        deleteFavoriteContact,
        getDashboardData,
        setCompanyExemption,
        updateVisibleDocumentSendEmailModal,
        preventDataLost,
        updateVisibleTimeReportClientPersonsModal,
        sendTimeReport,
        getTimeReportClientPersons,
        updateVisibleTimeReportSendEmailModal,
        getHeadersInvoicePayments,
        incompleteProfile,
        updateVisibleGuideModal,
        updateVisibleVobDocumentModal,
        vobDocuments,
        getLatestMeasurement,
        manageEmailForm,
        sendOffer,
        confirmInvoice,
        updateInvoice,
        isProjectInvoicesConfirmed,
        getProjectTimeReports,
        getProjectDiskUsage,
        getClientDiskUsage,
        getHeadersInvoicePaymentsList,
        getInvoicePaymentItems,
        deleteInvoicePaymentItem,
        updateVisibleTimeReportSummaryTableModal,
        getHeadersTimeReportSummary,
        confirmTimeReportSummary,
        getCountries,
        getProducts,
        storeProduct,
        updateProduct,
        deleteProduct,
        getAllProducts
    }
});
